import type { ApiFlow } from '../types'

export const samlIdpSpSetupFlow: ApiFlow = {
  id: 'saml_idp.sp-setup',
  appTypes: ['saml_idp'],
  title: 'SAML SP setup',
  summary:
    'Copy IntelliAuth IdP metadata and ACS URL into your downstream service (Salesforce, Jira, etc.). No HTTP login API.',
  steps: [
    {
      id: 'metadata',
      title: 'Download SP metadata',
      when: 'Configuring the downstream SAML service provider',
      method: 'GET',
      path: '/api/v1/applications/{{APP_ID}}/saml/metadata',
      operationId: 'samlMetadataXML',
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: { note: 'application/samlmetadata+xml — EntityID, SSO URL, certificate' },
          nextStepId: 'configure',
        },
      ],
    },
    {
      id: 'configure',
      title: 'Paste into downstream RP',
      when: 'Admin configures Salesforce / AWS / Jira SAML',
      method: 'GET',
      path: '<downstream-admin-console>',
      responseVariants: [
        {
          label: 'manual',
          status: 200,
          body: {
            entity_id: '{{ISSUER}}/saml/metadata',
            acs_url: '{{ISSUER}}/saml/acs',
            note: 'Map NameID to email; test SSO from downstream app',
          },
        },
      ],
    },
  ],
}
